// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: visible;
}
.avatar.avatar-active {
  outline: 3px solid #d4e280;
}
.avatar .corner-name {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  padding: 3px 5px;
  align-items: center;
  max-width: 100%;
  height: 25px;
  font-size: 14px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
}
.avatar .corner-name span.anticon {
  margin-right: 5px;
}
.avatar .center-name {
  font-size: 38px;
  font-weight: 700;
  color: #fff;
}
.avatar .you {
  font-size: 18px;
  color: #fff;
}
.avatar .more-button {
  position: absolute;
  top: 3px;
  right: 3px;
  border: 0;
  border-radius: 3px;
  background: #0171eb;
  display: none;
}
.avatar .more-button:hover {
  background: #2681f2;
}
.avatar .more-button.more-button-active {
  display: inline-block;
}
.avatar .avatar-volume {
  position: absolute;
  display: flex;
  align-items: center;
  opacity: 0.1;
  top: 10%;
  right: 2%;
  width: 20%;
}
.avatar .avatar-volume:hover {
  opacity: 0.5;
}
.avatar .avatar-volume label {
  transform: translateY(-10px);
  color: #ccc;
  font-size: 12px;
  margin-right: 5px;
}
.avatar .avatar-volume .ant-slider {
  flex: 1 1;
}
.avatar .avatar-volume .ant-slider-mark-text {
  color: #ccc;
}
@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/feature/video/components/avatar.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAAE;EACE,0BAAA;AAEJ;AAAE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AAAE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAEJ;AAAE;EACE,eAAA;EAEA,WAAA;AACJ;AACE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AACJ;AAAI;EACE,mBAAA;AAEN;AAAI;EACE,qBAAA;AAEN;AACE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AACJ;AAAI;EACE,YAAA;AAEN;AAAI;EACE,4BAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAEN;AAAI;EACE,SAAA;AAEN;AAAI;EACE,WAAA;AAEN;AACE;EACE;IACE,oBAAA;EACJ;EACE;IACE,yBAAA;EACJ;AACF","sourcesContent":[".avatar {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: visible;\n  &.avatar-active {\n    outline: 3px solid #d4e280;\n  }\n  .corner-name {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    display: flex;\n    padding: 3px 5px;\n    align-items: center;\n    max-width: 100%;\n    height: 25px;\n    font-size: 14px;\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.6);\n    span.anticon {\n      margin-right: 5px;\n    }\n  }\n  .center-name {\n    font-size: 38px;\n    font-weight: 700;\n    color: #fff;\n  }\n  .you {\n    font-size: 18px;\n    // font-weight: 700;\n    color: #fff;\n  }\n  .more-button {\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    border: 0;\n    border-radius: 3px;\n    background: #0171eb;\n    display: none;\n    &:hover {\n      background: #2681f2;\n    }\n    &.more-button-active {\n      display: inline-block;\n    }\n  }\n  .avatar-volume {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    opacity: 0.1;\n    top: 10%;\n    right: 2%;\n    width: 20%;\n    &:hover {\n      opacity: 0.5;\n    }\n    label {\n      transform: translateY(-10px);\n      color: #ccc;\n      font-size: 12px;\n      margin-right: 5px;\n    }\n    .ant-slider {\n      flex: 1;\n    }\n    .ant-slider-mark-text {\n      color: #ccc;\n    }\n  }\n  @keyframes loading {\n    0% {\n      transform: rotate(0);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
